import React from "react";
import "./SegmentedControl.css";

export default function SegmentedControl({ options, isSelected, onSelect, label }) {
  return (
    <div className="nfl-seg" role={label ? "group" : undefined} aria-label={label}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className="nfl-seg-option"
          aria-pressed={isSelected(option.value)}
          onClick={() => onSelect(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
